class CinemaPrint {
  constructor() {
    this.product = JSON.parse(document.getElementById('CinemaJson').textContent);

    this.priceEl = document.getElementById('cinemaPrice');
    this.sizesEl = document.getElementById('cinemaSizes');
    this.sizeSelected = document.getElementById('cinemaSizeSelected');
    this.variantIdInput = document.getElementById('cinemaVariantId');
    this.form = document.querySelector('.cinema__form');
    this.addBtn = document.getElementById('cinemaAddBtn');
    this.categoryInput = document.getElementById('cinemaCategory');
    this.titleInput = document.getElementById('cinemaTitle');

    this.uploadInput = document.getElementById('cinemaUploadInput');
    this.uploadPlace = document.getElementById('cinemaUploadPlace');
    this.uploadPreview = document.getElementById('cinemaUploadPreview');
    this.previewImg = document.getElementById('cinemaPreviewImg');
    this.previewRemove = document.getElementById('cinemaPreviewRemove');
    this.uploadError = document.getElementById('cinemaUploadError');
    this.upload = document.getElementById('cinemaUpload');

    this.acceptedTypes = ['image/jpeg', 'image/png', 'image/webp'];
    this.maxSize = 10 * 1024 * 1024;

    this._sizeChosen = false;
    this._uploaded = false;

    this.initSizes();
    this.initUpload();
    this.initInputs();
    this.initForm();
    this.validate();
  }

  initSizes() {
    const buttons = this.sizesEl.querySelectorAll('.cinema__size-btn');

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => {
          b.classList.remove('is-active');
          b.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        this._sizeChosen = true;
        this.selectSize(btn.getAttribute('data-size'));
        this.validate();
      });
    });
  }

  selectSize(size) {
    if (this.sizeSelected) {
      this.sizeSelected.textContent = size;
    }

    const variant = this.product.variants.find((v) => {
      return v.option1 && v.option1.toLowerCase() === size.toLowerCase();
    });

    if (variant) {
      const price = (variant.price / 100).toFixed(2);
      this.priceEl.textContent = '$' + price;

      if (this.variantIdInput) {
        this.variantIdInput.value = variant.id;
      }

      if (variant.available) {
        this.addBtn.disabled = false;
        this.addBtn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
      } else {
        this.addBtn.disabled = true;
        this.addBtn.innerHTML = 'SOLD OUT';
      }
    }
  }

  initInputs() {
    if (this.categoryInput) {
      this.categoryInput.addEventListener('input', () => this.validate());
    }
    if (this.titleInput) {
      this.titleInput.addEventListener('input', () => this.validate());
    }
  }

  validate() {
    const catOk = this.categoryInput && this.categoryInput.value.trim().length > 0;
    const titleOk = this.titleInput && this.titleInput.value.trim().length > 0;

    if (this._sizeChosen && catOk && titleOk && this._uploaded) {
      this.addBtn.disabled = false;
      this.addBtn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    } else {
      this.addBtn.disabled = true;
      if (!this._sizeChosen) {
        this.addBtn.innerHTML = 'SELECT A SIZE';
      } else if (!catOk) {
        this.addBtn.innerHTML = 'ENTER A CATEGORY';
      } else if (!titleOk) {
        this.addBtn.innerHTML = 'ENTER TITLE / NAMES';
      } else if (!this._uploaded) {
        this.addBtn.innerHTML = 'UPLOAD YOUR PHOTO';
      }
    }
  }

  initUpload() {
    if (!this.uploadInput) return;

    this.uploadInput.addEventListener('change', () => {
      this.handleFile(this.uploadInput.files);
    });

    this.upload.addEventListener('dragover', (e) => {
      e.preventDefault();
      this.upload.classList.add('drag-over');
    });

    this.upload.addEventListener('dragleave', () => {
      this.upload.classList.remove('drag-over');
    });

    this.upload.addEventListener('drop', (e) => {
      e.preventDefault();
      this.upload.classList.remove('drag-over');
      if (e.dataTransfer.files && e.dataTransfer.files.length) {
        this.uploadInput.files = e.dataTransfer.files;
        this.handleFile(e.dataTransfer.files);
      }
    });

    if (this.previewRemove) {
      this.previewRemove.addEventListener('click', (e) => {
        e.stopPropagation();
        this.clearUpload();
      });
    }
  }

  handleFile(files) {
    this.uploadError.hidden = true;

    if (!files || !files.length) {
      this.clearUpload();
      return;
    }

    const file = files[0];

    if (!this.acceptedTypes.includes(file.type)) {
      this.uploadError.hidden = false;
      this.clearUpload();
      return;
    }

    if (file.size > this.maxSize) {
      this.uploadError.hidden = false;
      this.clearUpload();
      return;
    }

    const reader = new FileReader();
    reader.onload = (e) => {
      this.uploadPlace.style.display = 'none';
      this.uploadPreview.style.display = 'block';
      this.previewImg.src = e.target.result;
      this.previewImg.hidden = false;
      this._uploaded = true;
      this.validate();
    };
    reader.readAsDataURL(file);
  }

  clearUpload() {
    this.uploadInput.value = '';
    this.uploadPlace.style.display = '';
    this.uploadPreview.style.display = 'none';
    this.previewImg.removeAttribute('src');
    this.previewImg.hidden = true;
    this._uploaded = false;
    this.validate();
  }

  initForm() {
    if (!this.form) return;

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      if (this.addBtn.disabled) return;

      this.addBtn.disabled = true;
      this.addBtn.innerHTML = 'ADDING...';

      const formData = new FormData(this.form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((r) => {
          if (!r.ok) throw new Error();
          return r.json();
        })
        .then(() => {
          this.addBtn.innerHTML = 'ADDED!';
          if (typeof openCartDrawer === 'function') openCartDrawer();
          if (typeof updateCartCount === 'function') updateCartCount();
          setTimeout(() => {
            this.addBtn.disabled = false;
            this.addBtn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
          }, 2000);
        })
        .catch(() => {
          this.addBtn.disabled = false;
          if (this._sizeChosen && this.categoryInput.value.trim() && this.titleInput.value.trim() && this._uploaded) {
            this.addBtn.innerHTML = 'ADD TO CART <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
          } else {
            this.addBtn.disabled = true;
            this.addBtn.innerHTML = 'FILL ALL FIELDS';
          }
        });
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.getElementById('CinemaJson')) {
    new CinemaPrint();
  }
});
